export function getErrors(state) {
	return state.errors;
}

export function getError(state, key) {
	return state.errors[key];
}
